var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.prefixCls,attrs:{"id":"productCore"}},[_c('div',{class:`${_vm.prefixCls}-header`},[_c('components-carousel-index',{attrs:{"carouselData":_vm.swipeList}})],1),_c('product-center')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }